module.exports = __webpack_public_path__ + "static/media/SEMBLANCE.7b1ad32c.pdf";